import { TFunction } from 'next-i18next';
import { z } from 'zod';
import { IWedding_RSVP } from '@bridebook/models/source/models/Weddings.types';
import { Rsvp } from '@bridebook/models/source/models/Weddings/Guests.types';

export const getGuestRsvpNameValidationSchema = (t: TFunction) =>
  z.object({
    fullName: z.string().min(1, t('weddingWebsite:rsvp.name.required')),
  });

export const validateGuestRsvpEventAttendance = (value: Rsvp = Rsvp.PENDING) =>
  [Rsvp.YES, Rsvp.NO].includes(value);

const TEXT_QUESTION_ANSWER_MAX_LENGTH = 1000;

const getQuestionSchema = (question: IWedding_RSVP['questions'][number], t: TFunction) => {
  switch (question.type) {
    case 'boolean':
      return z.boolean();

    case 'list':
      return z.string().refine((val) => question.options?.includes(val));

    case 'string':
      return z
        .string()
        .trim()
        .min(1, t('weddingWebsite:rsvp.questionValidation.required'))
        .max(
          TEXT_QUESTION_ANSWER_MAX_LENGTH,
          t('weddingWebsite:rsvp.questionValidation.max', {
            length: TEXT_QUESTION_ANSWER_MAX_LENGTH,
          }),
        );
  }
};

export const getGuestRsvpQuestionValidator =
  (question: IWedding_RSVP['questions'][number], t: TFunction) => (value?: string | boolean) => {
    const schema = getQuestionSchema(question, t);
    const result = schema.safeParse(value);

    return result.success ? undefined : result.error.errors[0].message;
  };
